// Uma consulta por vez; eventos recebidos durante a consulta preservam uma
// atualização posterior. A janela fixa também atende rajadas contínuas.
export function agruparAtualizacaoAvisos(buscar: () => Promise<void>, intervalo = 1000) {
  let encerrado = false;
  let executando = false;
  let pendente = false;
  let timer: ReturnType<typeof setTimeout> | undefined;
  const agendar = () => {
    if (encerrado || executando || timer || !pendente) return;
    timer = setTimeout(() => { timer = undefined; void executar(); }, intervalo);
  };
  const executar = async () => {
    if (encerrado || executando) return;
    pendente = false;
    executando = true;
    try { await buscar(); }
    finally { executando = false; agendar(); }
  };
  return {
    iniciar: () => { void executar(); },
    solicitar: () => { pendente = true; agendar(); },
    encerrar: () => { encerrado = true; if (timer) clearTimeout(timer); },
  };
}
